module.exports = __webpack_public_path__ + "static/media/renjun-4.jpeg";